import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d43a1c26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-item list-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tablet" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tablet" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = { class: "list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_chip = _resolveComponent("ion-chip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsByPoId, (poItems, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      _createVNode(_component_ion_item, { lines: "none" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", null, _toDisplayString(index), 1)
        ]),
        _: 2
      }, 1024),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGroupPurchaseOrders(poItems), (id) => {
        return (_openBlock(), _createElementBlock("div", { key: id }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getParentInformation(id, poItems).parentProductName), 1)
              ]),
              _: 2
            }, 1024),
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_ion_checkbox, {
              "aria-label": "select-virtual",
              checked: _ctx.isParentProductChecked(id, poItems),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isParentProductUpdated = true)),
              onIonChange: ($event: any) => (_ctx.selectParentProduct(id, $event, poItems))
            }, null, 8, ["checked", "onIonChange"]),
            _createVNode(_component_ion_button, {
              fill: "clear",
              color: "medium",
              onClick: ($event: any) => (_ctx.openProductPopover($event, id, true, _ctx.getParentInformation(id, poItems), _ctx.getParentInformation(id, poItems).orderId))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: _ctx.ellipsisVerticalOutline
                }, null, 8, ["icon"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGroupedItems(id, poItems), (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxpShopifyImg, {
                          src: item.imageUrl,
                          size: "small"
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.pseudoId)) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.pseudoId)) : item.pseudoId), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(item.pseudoId))), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_chip, {
                  outline: "",
                  class: "tablet"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.isNewProduct === "Y"? _ctx.translate("Preorder") : _ctx.translate("Backorder")), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_chip, { outline: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.quantityOrdered) + " " + _toDisplayString(_ctx.translate("Ordered")), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_chip, {
                  outline: "",
                  class: "tablet"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.sendOutline }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getArrivalDate(item.arrivalDate)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(), _createBlock(_component_ion_checkbox, {
                  "aria-label": "select-variant",
                  key: item.isSelected,
                  checked: item.isSelected,
                  onIonChange: ($event: any) => (_ctx.selectProduct(item, $event))
                }, null, 8, ["checked", "onIonChange"])),
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  color: "medium",
                  onClick: ($event: any) => (_ctx.openProductPopover($event, item.pseudoId, false, item, item.orderId))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "icon-only",
                      icon: _ctx.ellipsisVerticalOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ]))
  }), 128))
}